import { motion, useInView } from "motion/react";
import { useRef } from "react";

const stats = [
  { value: "Top 5", label: "Daytona 24h", sublabel: "out of 600+ teams" },
  { value: "2x", label: "DNLS Season", sublabel: "Victories" },
  { value: "5000+", label: "iRating", sublabel: "Team Average" },
  { value: "50+", label: "Setups", sublabel: "Every Week" },
  { value: "6", label: "Pro Drivers", sublabel: "On the Team" },
];

export function StatsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="stats" className="relative py-24 px-4" ref={ref}>
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5 md:gap-4">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group flex flex-col items-center text-center"
            >
              <span
                className="font-mono text-4xl font-bold text-foreground md:text-5xl"
                style={{ fontFamily: "'JetBrains Mono Variable', monospace" }}
              >
                {stat.value}
              </span>
              <span className="mt-2 text-sm font-semibold uppercase tracking-wider text-folk-blue">
                {stat.label}
              </span>
              <span className="text-xs text-muted-foreground">{stat.sublabel}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
